export function isNotBlank(string) {
  if (string == null) {
    return false;
  } else if (string == undefined) {
    return false;
  } else if (string.length == 0) {
    return false;
  } else {
    return true;
  }
}

/** 判断对象是否为空 */
export function judgeObj(obj) {
  if (JSON.stringify(obj) == "{}" || obj == null) return true;
  else return false;
}

/** 判断数组是否为空 */
export function judgeArray(arr) {
  if (arr.length == 0 || arr == null || arr == undefined) return true;
  else return false;
}


//判断是否是字符串
export function isString(str) {
  if (Object.prototype.toString.call(str) === "[object String]") {
    return true;
  } else {
    return false;
  }
}

/**
 * 手机号码校验
 */
//   /^[1](([3][0-9])|([4][5-9])|([5][0-3,5-9])|([6][5,6])|([7][0-8])|([8][0-9])|([9][1,8,9]))[0-9]{8}$/
export function phoneNumber(value) {
  if (value && (!(/^[1][34578]\d{9}$/).test(value) || !(/^[1-9]\d*$/).test(value) || value.length !== 11)) {
    return false
  } else {
    return true
  }
}

/**
 * 电话号码校验
 */
export function telephoneNumber(value) {
  if (value && (!(/^((0\d{2,3}-\d{7,8})|(1[3584]\d{9}))$/).test(value))) {
    return false
  } else {
    return true
  }
}


/** 正则验证身份证号码 */

export function checkID(val) {
  if (checkCode(val)) {
    var date = val.substring(6, 14);
    if (checkDate(date)) {
      if (checkProv(val.substring(0, 2))) {
        return true;
      }
    }
  }
  return false;
}
var checkCode = function (val) {
  var p = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
  var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
  var parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2];
  var code = val.substring(17);
  if (p.test(val)) {
    var sum = 0;
    for (var i = 0; i < 17; i++) {
      sum += val[i] * factor[i];
    }
    if (parity[sum % 11] == code.toUpperCase()) {
      return true;
    }
  }
  return false;
}
var checkDate = function (val) {
  var pattern = /^(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)$/;
  if (pattern.test(val)) {
    var year = val.substring(0, 4);
    var month = val.substring(4, 6);
    var date = val.substring(6, 8);
    var date2 = new Date(year + "-" + month + "-" + date);
    if (date2 && date2.getMonth() == (parseInt(month) - 1)) {
      return true;
    }
  }
  return false;
}
var checkProv = function (val) {
  var pattern = /^[1-9][0-9]/;
  var provs = {
    11: "北京",
    12: "天津",
    13: "河北",
    14: "山西",
    15: "内蒙古",
    21: "辽宁",
    22: "吉林",
    23: "黑龙江 ",
    31: "上海",
    32: "江苏",
    33: "浙江",
    34: "安徽",
    35: "福建",
    36: "江西",
    37: "山东",
    41: "河南",
    42: "湖北 ",
    43: "湖南",
    44: "广东",
    45: "广西",
    46: "海南",
    50: "重庆",
    51: "四川",
    52: "贵州",
    53: "云南",
    54: "西藏 ",
    61: "陕西",
    62: "甘肃",
    63: "青海",
    64: "宁夏",
    65: "新疆",
    71: "台湾",
    81: "香港",
    82: "澳门"
  };
  if (pattern.test(val)) {
    if (provs[val]) {
      return true;
    }
  }
  return false;
}



/** 正则验证身份证号码 */
export function verifyIDCard(id) {
  // 1 "验证通过!", 0 //校验不通过
  var format = /^(([1][1-5])|([2][1-3])|([3][1-7])|([4][1-6])|([5][0-4])|([6][1-5])|([7][1])|([8][1-2]))\d{4}(([1][9]\d{2})|([2]\d{3}))(([0][1-9])|([1][0-2]))(([0][1-9])|([1-2][0-9])|([3][0-1]))\d{3}[0-9xX]$/;
  //号码规则校验
  if (!format.test(id)) {
    return {
      'status': 0,
      'msg': '身份证号码不合规'
    };
  }
  //区位码校验
  //出生年月日校验   前正则限制起始年份为1900;
  var year = id.substr(6, 4), //身份证年
    month = id.substr(10, 2), //身份证月
    date = id.substr(12, 2), //身份证日
    time = Date.parse(month + '-' + date + '-' + year), //身份证日期时间戳date
    now_time = Date.parse(new Date()), //当前时间戳
    dates = (new Date(year, month, 0)).getDate(); //身份证当月天数
  if (time > now_time || date > dates) {
    return {
      'status': 0,
      'msg': '出生日期不合规'
    }
  }
  //校验码判断
  var c = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2); //系数
  var b = new Array('1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'); //校验码对照表
  var id_array = id.split("");
  var sum = 0;
  for (var k = 0; k < 17; k++) {
    sum += parseInt(id_array[k]) * parseInt(c[k]);
  }
  if (id_array[17].toUpperCase() != b[sum % 11].toUpperCase()) {
    return {
      'status': 0,
      'msg': '身份证校验码不合规'
    }
  }
  return {
    'status': 1,
    'msg': '校验通过'
  }
}


// 获取当前时间  年月日  时分秒
export function dateNow() {
  var now = new Date();
  var yy = now.getFullYear(); //年
  var mm = now.getMonth() + 1; //月
  var dd = now.getDate(); //日
  var hh = now.getHours(); //时
  var ii = now.getMinutes(); //分
  var ss = now.getSeconds(); //秒
  var time = yy + "-";
  if (mm < 10) time += "0";
  time += mm + "-";
  if (dd < 10) time += "0";
  time += dd + " ";
  if (hh < 10) time += "0";
  time += hh + ":";
  if (ii < 10) time += '0';
  time += ii + ":";
  if (ss < 10) time += '0';
  time += ss;
  return time
}
// 获取当前时间 年月日
export function dateNowYear() {
  var now = new Date();
  var yy = now.getFullYear(); //年
  var mm = now.getMonth() + 1; //月
  var dd = now.getDate(); //日
  var time = yy + "-";
  if (mm < 10) time += "0";
  time += mm + "-";
  if (dd < 10) time += "0";
  time += dd + " ";
  return time
}
